import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHeader } from "./Reveal";
import { INDUSTRIES } from "../data/site";

const Industries = () => {
  const [active, setActive] = useState(0);
  const item = INDUSTRIES[active];

  return (
    <section id="industries" data-testid="industries-section" className="relative py-28 md:py-40">
      <div className="max-w-6xl mx-auto px-6">
        <SectionHeader
          index={5}
          overline="Industries"
          title={<>Deep Context,<br /><span className="text-smipl-orange">Every Sector.</span></>}
          sub="Infrastructure decisions look different in a hospital than on a factory floor. We design for your reality."
        />
        <Reveal>
          <div className="flex flex-wrap gap-2.5 mb-10">
            {INDUSTRIES.map((ind, i) => (
              <button
                key={ind.id}
                data-testid={`industry-tab-${ind.id}`}
                onClick={() => setActive(i)}
                className={`flex items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-medium transition-all duration-300 ${
                  active === i
                    ? "border-smipl-orange bg-smipl-orange/10 text-white"
                    : "border-white/10 text-slate-400 hover:border-white/25 hover:text-white"
                }`}
              >
                <ind.icon size={15} className={active === i ? "text-smipl-orange" : ""} />
                {ind.name}
              </button>
            ))}
          </div>
        </Reveal>
        <AnimatePresence mode="wait">
          <motion.div
            key={item.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`industry-panel-${item.id}`}
            className="rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.05] to-transparent p-8 md:p-12 grid md:grid-cols-2 gap-10"
          >
            <div>
              <item.icon size={36} className="text-smipl-orange" />
              <h3 className="mt-5 font-display text-2xl md:text-3xl font-bold">{item.name}</h3>
              <p className="mt-4 text-slate-400 text-base leading-relaxed">{item.blurb}</p>
            </div>
            <div className="grid gap-3 content-center">
              {item.capabilities.map((c) => (
                <div key={c} className="flex items-center gap-3 rounded-xl border border-white/8 bg-navy-deep/60 px-4 py-3.5">
                  <Check size={15} className="text-smipl-orange shrink-0" />
                  <span className="text-sm text-slate-300">{c}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>
        <Reveal delay={0.15} className="mt-10">
          <Link to="/industries" data-testid="industries-view-all" className="group inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-smipl-orange hover:text-smipl-amber transition-colors">
            View all industry pages <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default Industries;
